import { DateTime } from "luxon";

const getOffset = (date: DateTime) => {
  const offset = date.offset; // in minutes
  const sign = offset >= 0 ? "+" : "-";
  const abs = Math.abs(offset);
  const hours = Math.floor(abs / 60)
    .toString()
    .padStart(2, "0");
  const minutes = (abs % 60).toString().padStart(2, "0");
  return `${sign}${hours}:${minutes}`;
};

const getOffsetLabel = (zone: string): string => {
  const nextYear = DateTime.now().plus({ years: 1 }).year;
  const winter = DateTime.fromISO(`${nextYear}-01-01`, { zone });
  const summer = DateTime.fromISO(`${nextYear}-07-01`, { zone });

  const winterOffset = getOffset(winter);
  const summerOffset = getOffset(summer);

  return winterOffset === summerOffset
    ? `(UTC${winterOffset})`
    : `(UTC${winterOffset}/${summerOffset})`;
};

const getCityName = (zone: string): string => zone.split("/").pop()?.replace(/_/g, " ") || zone;

const buildTimeZoneOptions = (): { title: string; value: string }[] =>
  (typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : [])
    .map((zone) => {
      const offsetLabel = getOffsetLabel(zone);
      const city = getCityName(zone);
      return {
        title: `${offsetLabel} ${city}`,
        value: zone,
      };
    })
    .sort((a, b) => a.title.localeCompare(b.title));

export const timeZoneOptions = buildTimeZoneOptions();
